<template>
  <div>
    <TelaLoading :overlay="loading" class="loading-pdf"></TelaLoading>
    <iframe
      :src="path"
      ref="iframePdf"
      name="pdfjsview"
      @load="carregarDocumento"
    ></iframe>
  </div>
</template>

<script>
import TelaLoading from "@/views/components/TelaLoading.vue";
import RegistroImagemService from "../../../common/services/http/registroImagem.service";

export default {
  name: "PDFJSViewer",
  components: { TelaLoading },
  data() {
    return {
      path: process.env.VUE_APP_VIEW_PDF,
      loading: false,
      blobFile: null,
    };
  },
  props: {
    fileName: {
      type: [Object, Blob],
    },
  },
  watch: {
    fileName(newValue) {
      if (Object.keys(newValue) > 0 || newValue instanceof Blob)
        this.carregarDocumento();
    },
  },
  methods: {
    async carregarDocumento() {
      if (
        Object.keys(this.fileName).length == 0 &&
        !(this.fileName instanceof Blob)
      )
        return;
      this.loading = true;
      const blob =
        this.fileName instanceof Blob
          ? this.fileName
          : await RegistroImagemService.visualizar(this.fileName.id);
      this.blobFile = blob;
      setTimeout(() => {
        var reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = () => {
          this.$refs.iframePdf.contentWindow.frames.postMessage(blob, "*");
        };
      }, 1000);
    },
  },
  mounted() {
    window.addEventListener("message", () => {
      this.loading = false;
    });
  },
};
</script>
<style scoped>
div {
  margin-left: 12px;
  margin-top: 12px;
  height: calc(100vh - 64px);
  min-width: 400px;
  overflow: hidden;
  position: relative;
}

iframe {
  width: calc(100% - 12px);
  height: 100%;
}
div > .loading-pdf {
  width: 100%;
  height: 100%;
  margin: 0;
  position: absolute;
}
</style>
